import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Layout/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

import Auth from "@/services/Auth";

const routes = [
  {
    path: '/',
    redirect: 'edit-profile',
    component: DashboardLayout,
    children: [
      {
        path: '/suspend',
        name: 'suspend',
        component: () => import('../views/Suspend.vue')
      },
      {
        path: '/kyc',
        name: 'kyc',
        component: () => import('../views/Kyc.vue')
      },
      {
        path: '/deposit',
        name: 'deposit',
        component: () => import('../views/NewDeposit.vue')
      },
      {
        path: '/choose-card',
        name: 'choose-card',
        component: () => import('../views/New-Deposit/ChooseCard.vue')
      },
      {
        path: '/deposit-method',
        name: 'deposit-method',
        props:route=>({
          card_number:route.query.card_number
        }),
        component: () => import('../views/New-Deposit/DepositMethod.vue')
      },
      {
        path: '/digital-assets',
        name: 'digital-assets',
        props:route=>({
          card_number:route.query.card_number,
          network:route.query.network
        }),
        component: () => import('../views/New-Deposit/DigitalAssets.vue')
      },
      {
        path: '/alipay',
        name: 'alipay',
        props:route=>({
          card_number:route.query.card_number
        }),
        component: () => import('../views/New-Deposit/Alipay.vue')
      },
      {
        path: '/wechatpay',
        name: 'wechatpay',
        props:route=>({
          card_number:route.query.card_number
        }),
        component: () => import('../views/New-Deposit/Wechatpay.vue')
      },
      // {
      //   path: '/deposit',
      //   name: 'deposit',
      //   component: () => import('../views/Deposit.vue')
      // },
      {
        path: '/change-atm-pin',
        name: 'change-atm-pin',
        props:route=>({
          card_number:route.query.card_number
        }),
        component: () => import('../views/ChangeAtmPin.vue')
      },
      {
        path: '/card-management',
        name: 'card-management',
        component: () => import('../views/Card-Management/zero-new.vue')
      },
      {
        path: '/order-card',
        name: 'order-card',
        props:route=>({
          relation:route.query.relation,
          relation_id:route.query.relation_id,
          name:route.query.name
        }),
        component: () => import('../views/New-Card-Management/OrderNewCard.vue')
      },
      {
        path: '/fill-in-details',
        name: 'fill-in-details',
        props:route=>({
          relation:route.query.relation,
          relation_id:route.query.relation_id,
          name:route.query.name
        }),
        component: () => import('../views/New-Card-Management/ApplyInfo.vue')
      },
      {
        path: '/payment-method',
        name: 'payment-method',
        props:route=>({
          relation:route.query.relation,
          relation_id:route.query.relation_id,
          name:route.query.name
        }),
        component: () => import('../views/New-Card-Management/PaymentMethod.vue')
      },
      {
        path: '/application-fee',
        name: 'application-fee',
        props:route=>({
          relation:route.query.relation,
          relation_id:route.query.relation_id,
          name:route.query.name
        }),
        component: () => import('../views/New-Card-Management/ApplicationFee.vue')
      },
      {
        path: '/qr-transaction',
        name: 'qr-transaction',
        component: () => import('../views/QRTransaction/qrTransaction.vue')
      },
      {
        path: '/qr-details',
        name: 'qr-details',
        component: () => import('../views/QRTransaction/qrDetails.vue')
      },
      {
        path: '/qr-choose-card',
        name: 'transfer',
        component: () => import('../views/QRTransaction/qrChooseCard.vue')
      },
      {
        path: '/transaction-info',
        name: 'transaction-info',
        component: () => import('../views/QRTransaction/transactionInfo.vue')
      },
      {
        path: '/scan-qr',
        name: 'scan-qr',
        props:route=>({
          trans_no:route.query.trans_no
        }),
        component: () => import('../views/QRTransaction/scanQR.vue')
      },
      {
        path: '/transfer',
        name: 'transfer',
        component: () => import('../views/Transfer/transfer.vue')
      },
      {
        path: '/transfer-choose-card',
        name: 'transfer-choose-card',
        component: () => import('../views/Transfer/chooseCard.vue')
      },
      {
        path: '/transfer-method',
        name: 'transfer-method',
        props:route=>({
          card_number:route.query.card_number,
          currency:route.query.currency
        }),
        component: () => import('../views/Transfer/transferMethod.vue')
      },
      {
        path: '/transfer-type',
        name: 'transfer-type',
        props:route=>({
          card_number:route.query.card_number,
          currency:route.query.currency
        }),
        component: () => import('../views/Transfer/transferType.vue')
      },
      {
        path: '/TT-same-name',
        name: 'TT-same-name',
        props:route=>({
          card_number:route.query.card_number
        }),
        component: () => import('../views/Transfer/TTSameName.vue')
      },
      {
        path: '/TT-third-party',
        name: 'TT-third-party',
        props:route=>({
          card_number:route.query.card_number
        }),
        component: () => import('../views/Transfer/TTThirdParty.vue')
      },
      {
        path: '/cc',
        name: 'cc',
        props:route=>({
          card_number:route.query.card_number
        }),
        component: () => import('../views/Transfer/cc.vue')
      },
      {
        path: '/summary',
        name: 'summary',
        component: () => import('../views/Transfer/summary.vue')
      },
      {
        path: '/summarycc',
        name: 'summarycc',
        component: () => import('../views/Transfer/summarycc.vue')
      },
      {
        path: '/transfer-details',
        name: 'transfer-details',
        props:route=>({
          trans_no:route.query.trans_no,
          type:route.query.type
        }),
        component: () => import('../views/Transfer/transferDetails.vue')
      },
      {
        path: '/deposit-details',
        name: 'deposit-details',
        props:route=>({
          trans_no:route.query.trans_no
        }),
        component: () => import('../views/New-Deposit/depositDetails.vue')
      },
      {
        path: '/edit-profile',
        name: 'edit-profile',
        component: () => import('../views/EditProfile.vue')
      },
      {
        path: '/system-configuration',
        name: 'system-configuration',
        component: () => import('../views/Settings/SystemConfiguration.vue')
      },  
      {
        path: '/change-password',
        name: 'change-password',
        component: () => import('../views/Settings/ChangePassword.vue')
      },
      {
        path: '/deposit-report',
        name: 'deposit-report',
        component: () => import('../views/DepositReport.vue')
      },
      {
        path: '/transfer-report',
        name: 'transfer-report',
        component: () => import('../views/TransferReport.vue')
      },
      {
        path: '/request-employee',
        name: 'request-employee',
        props:route=>({
          id:route.query.id
        }),
        component: () => import('../views/Account/RequestEmployee.vue')
      },
      {
        path: '/account-information',
        name: 'account-information',
        props:route=>({
          name:route.query.name,
          email:route.query.email,
          dob:route.query.dob,
          relation:route.query.relation,
          phone_code:route.query.phone_code,
          phone:route.query.phone,
          doc_type:route.query.doc_type,
          error_name:route.query.error_name,
          error_email:route.query.error_email,
          error_dob:route.query.error_dob,
          error_relation:route.query.error_relation,
          error_phone_code:route.query.error_phone_code,
          error_phone:route.query.error_phone
        }),
        component: () => import('../views/Account/AccountInformation.vue')
      },
      {
        path: '/corporate-company-information',
        name: 'corporate-company-information',
        component: () => import('../views/Account/CorporateCompanyInformation.vue')
      },
      {
        path: '/director-information',
        name: 'director-information',
        component: () => import('../views/Account/CorporateDirectorInformation.vue')
      },
      {
        path: '/corporate-beneficiary',
        name: 'corporate-beneficiary',
        component: () => import('../views/Account/CorporateBeneficiaryInformation.vue')
      },
      {
        path: '/corporate-summary',
        name: 'corporate-summary',
        component: () => import('../views/Account/CorporateSummary.vue')
      },
      {
        path: '/document-verification',
        name: 'document-verification',
        props:route=>({
          name:route.query.name,
          email:route.query.email,
          dob:route.query.dob,
          relation:route.query.relation,
          phone_code:route.query.phone_code,
          phone:route.query.phone,
          doc_type:route.query.doc_type
        }),
        component: () => import('../views/Account/DocumentVerification.vue')
      },
      {
        path: '/account-summary',
        name: 'account-summary',
        props:route=>({
          name:route.query.name,
          email:route.query.email,
          dob:route.query.dob,
          relation:route.query.relation,
          phone_code:route.query.phone_code,
          phone_country:route.query.phone_country,
          phone:route.query.phone,
          doc_type:route.query.doc_type
        }),
        component: () => import('../views/Account/AccountSummary.vue')
      },
      {
        path: '/account',
        name: 'account',
        component: () => import('../views/Account.vue')
      },
      {
        path: '/transaction',
        name: 'transaction',
        component: () => import('../views/Transaction.vue')
      },
      {
        path: '/cs',
        name: 'customer-service',
        component: () => import('../views/CustomerService.vue')
      },
      {
        path: '/faq',
        name: 'faq',
        component: () => import('../views/Faq.vue')
      },
      // {
      //   path: '/card-tracking',
      //   name: 'card-tracking',
      //   component: () => import('../views/Shipping.vue')
      // },
      {
        path: "/logout",
        name: "logout",
        component: {
          beforeRouteEnter(to, from, next) {
            let currentToken = localStorage.getItem("notification_token");
            if(currentToken){
              Auth.logout({ fcm_token: currentToken }).then(response=>{
                if(response.status == 200){
                  localStorage.removeItem("notification_token");
                  localStorage.removeItem("token");
                  localStorage.removeItem("member");
                  localStorage.removeItem("isFirstTime");
                  location.reload();
                }
              });
            }
            else{
                localStorage.removeItem("token");
                localStorage.removeItem("member");
                localStorage.removeItem("isFirstTime");
                location.reload();
            }
          }
        }
      },
      // {
      //   path: "/network-address",
      //   name: "network-address",
      //   component: () => import('../views/NetworkAddress/NetworkAddress.vue')
      // },
      // {
      //   path: "/network-address/create",
      //   name: "create-network-address",
      //   component: () => import('../views/NetworkAddress/NetworkAddressForm.vue')
      // }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        meta:{
          noBodyBackground:true
        },
        props:route=>({
          token:route.query.verification,
          register:route.query.register
        }),
        component: () => import('../views/Auth/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        meta:{
          noBodyBackground:true
        },
        component: () => import('../views/Auth/Register.vue')
      },
      {
        path: '/forgot-password',
        name: 'forgot-password',
        meta:{
          noBodyBackground:true
        },
        component: () => import('../views/Auth/ForgotPassword.vue')
      },
      {
        path: '/resend-email',
        name: 'resend-email',
        meta:{
          noBodyBackground:true
        },
        component: () => import('../views/Auth/ResendEmail.vue')
      },
      {
        path: '/term-condition',
        name: 'term-condition',
        meta:{
          noBodyBackground:true
        },
        component: () => import('../views/TermCondition.vue')
      },
      {
        path: '/privacy-policy-statement',
        name: 'privacy-policy-statement',
        meta:{
          noBodyBackground:true
        },
        component: () => import('../views/PrivacyPolicy.vue')
      },
      {
        path: '/maintenance',
        name: 'maintenances',
        component: () => import('../views/Maintenance.vue')
      },
      {
        path: '/payment',
        name: 'payment',
        meta:{
          noBodyBackground:true
        },
        component: () => import('../views/PendingPayment.vue')
      },
      { path: '*', component: NotFound },
    ]
  }
];

export default routes;
